<template>
  <div class="verify-code">
    <p>
      {{
        $t("driver_onboarding.step_progress_bar.step", {
          num: $route.meta.step_id,
        })
      }}
    </p>
    <h1>{{ $t("driver_onboarding.auth.signin") }}</h1>

    <h3>{{ $t("driver_onboarding.auth.activate_title") }}</h3>
    <div class="verify-input_code">
      <InputCode
        @onSubmit="onSubmitActivationCode"
        :length="activateCodeLength"
        ref="inputCode"
      />
    </div>
    <div class="note">
      <p class="wrong-code" v-if="error">{{ error }}</p>
      <span
        class="verify-note"
        v-html="
          $t('driver_onboarding.auth.activate_hint', {
            mobile: $route.query.id,
          })
        "
      >
      </span>
      <br />
      <span id="re-captcha"></span>
      <p
        class="verify-note request-otp"
        v-if="!resendOTPButtonVisible"
        v-html="
          $t('driver_onboarding.auth.resend_otp', { seconds: coundownNumber })
        "
      ></p>
      <p
        v-else
        @click="handleResendOTP"
        class="verify-note resend-otp"
        href="javascript:;"
      >
        {{ $t("driver_onboarding.auth.resend_otp_btn") }}
      </p>
    </div>
    <div class="change-mobile">
      <img src="/img/icons/arrow-left-warning.svg" alt />
      <span @click="goToLoginPage">
        {{ $t("driver_onboarding.auth.change_mobile") }}
      </span>
    </div>

    <b-loading :is-full-page="true" :active.sync="loading"></b-loading>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import InputCode from "./InputCode.vue";
import { setItemStorage } from "@/plugins/utils";
import firebaseAuth from "./firebase-auth.mixin";

const TIME_LEFT = 59;
export default {
  mixins: [firebaseAuth],
  data() {
    return {
      loading: false,
      error: null,
      coundownNumber: TIME_LEFT,
      resendOTPInterval: null,
    };
  },
  components: {
    InputCode,
  },
  computed: {
    ...mapGetters(["firebaseConfirmation"]),
    mobile() {
      return this.$route && this.$route.query && this.$route.query.id;
    },
    useFirebaseLogin() {
      const authenticateType =
        this.$route && this.$route.query && this.$route.query.authenticate_type;
      return authenticateType === "ahamove";
    },
    activateCodeLength() {
      return this.useFirebaseLogin
        ? this.$constants.NUMBER_OF_ACTIVATE_CODE.FIREBASE
        : this.$constants.NUMBER_OF_ACTIVATE_CODE.AHAMOVE;
    },
    resendOTPButtonVisible() {
      return this.coundownNumber <= 0;
    },
  },
  methods: {
    onSubmitActivationCode(code) {
      // console.log('handleActiveCode', code)
      this.loading = true;

      if (!this.useFirebaseLogin) return this.handleActivateSupplier(code);

      if (!this.firebaseConfirmation) {
        return this.goToLoginPage();
      }

      this.firebaseConfirmation
        .confirm(code)
        .then((result) => {
          result &&
            result.user &&
            result.user.getIdToken().then((token) => {
              this.handleActivateSupplier(token);
            });
        })
        .catch((error) => {
          console.log("error", error);
          this.$refs.inputCode.reset();
          // // User couldn't sign in (bad verification code?)
          if (error.code === "auth/code-expired") {
            // The SMS code has expired. Please re-send the verification code to try again.
            this.showMessage(
              this.$t("driver_onboarding.auth.activate_code_expired")
            );
          } else if (error.code === "auth/invalid-verification-code") {
            this.showMessage(
              this.$t("driver_onboarding.auth.invalid_verification_code")
            );
          } else {
            this.showMessage(
              this.$t("driver_onboarding.auth..cannot_activate_account")
            );
          }

          this.loading = false;
        });
    },

    handleActivateSupplier(activation_code) {
      const params = {
        mobile: this.mobile,
        activation_code: activation_code,
        imei: "web",
        type: "web",
        fcm: true,
        push: "web",
        app: "AhaMove",
      };
      this.$store
        .dispatch("driverActivate", params)
        .then((response) => {
          this.activateSuccess(response);
        })
        .catch((error) => {
          this.activateFail(error);
        });
    },
    activateSuccess(response) {
      const token = response.data.token;
      const query = this.$route.query;
      let redirectUri = "";

      if (!token) {
        return;
      }

      if (query && query.redirect_uri) {
        redirectUri = query.redirect_uri;
      }

      this.$setCookie("supplier_token", token);
      this.$store.dispatch("setSupplierToken", token);
      this.$store
        .dispatch("getProfile", token)
        .then((result) => {
          if (result.data.supplier._id && result.data.supplier.name) {
            if (result.data && result.data.supplier) {
              this.$store.dispatch("setSupplierProfile", result.data.supplier);
              setItemStorage("supplier", JSON.stringify(result.data.supplier));

              if (redirectUri) {
                this.$router.push({ path: decodeURIComponent(redirectUri) });
                return;
              }

              if (
                ((result.data.supplier.extra &&
                  (result.data.supplier.extra.contract_signing_url ||
                    result.data.supplier.extra.is_contracted)) ||
                  result.data.supplier.verified) &&
                screen.width >= 1024
              ) {
                this.$router.push({ name: "contract" });
              } else {
                this.$root.$emit("moveToNextStep");
              }
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    activateFail(error) {
      if (!error) return;

      this.loading = false;
      this.error = null;
      this.$refs.inputCode.reset();

      switch (error.status) {
        case 400:
          break;
        case 404:
          this.error = error.data.description;
          break;
        case 403:
          this.error = error.data.description;
          break;
        case 406:
          // this.error = "Mã xác nhận không đúng!";
          this.$buefy.notification.open({
            message: error.data.description,
            type: "is-danger",
            duration: 3000,
            position: "is-bottom",
          });
          break;
        default:
          this.$buefy.notification.open({
            message: `Lỗi ${error.status}: ${error.data.description}`,
            type: "is-danger",
            duration: 3000,
            position: "is-bottom",
          });
      }
    },
    showMessage(msg) {
      this.$buefy.notification.open({
        message: msg,
        type: "is-danger",
        duration: 3000,
        position: "is-bottom",
      });
    },
    goToLoginPage() {
      this.$router.push({
        name: "signin",
      });

      this.$gtag("event", this.$trackingEvents.EVENTS.CHANGE_MOBILE, {
        event_category: this.$route.path,
      });
    },
    resetTimer() {
      this.$setCookie(
        "timer",
        JSON.stringify({
          id: this.mobile,
          start: new Date(),
        })
      );
    },
    handleCountTime() {
      const timerStr = this.$getCookie("timer");
      const timer = timerStr && JSON.parse(timerStr);
      const coundown = (start) => {
        const now = new Date();
        this.coundownNumber =
          TIME_LEFT - parseInt(now.getTime() / 1000 - start.getTime() / 1000);
      };

      if (timer.id === this.$route.query.id) {
        const start = new Date(timer.start);
        coundown(start);

        this.resendOTPInterval = setInterval(() => {
          coundown(start);

          if (this.coundownNumber <= 0) {
            clearInterval(this.resendOTPInterval);
          }
        }, 1000);
      }
    },
    handleResendOTP() {
      this.loading = true;
      if (this.useFirebaseLogin) {
        return this.$_firebaseAuth_sendOTP(this.mobile)
          .then((firebase_confirmation) => {
            this.$store.dispatch(
              "setFirebaseConfirmation",
              firebase_confirmation
            );
            this.resetTimer();
            this.handleCountTime();
            this.loading = false;
          })
          .catch((e) => {
            this.$buefy.notification.open({
              message: e,
              type: "is-danger",
              duration: 3000,
              position: "is-bottom",
            });
            this.loading = false;
          });
      }

      const data = {
        mobile: this.mobile,
        firebase_sms_auth: this.useFirebaseLogin,
      };
      this.$store.dispatch("driverLogin", data).then(() => {
        this.resetTimer();
        this.handleCountTime();
        this.loading = false;
      });

      this.$gtag("event", this.$trackingEvents.EVENTS.RESEND_OTP, {
        event_category: this.$route.path,
      });
    },
  },
  mounted() {
    this.handleCountTime();
  },
};
</script>
<style lang="scss" scoped>
.verify-code {
  .note {
    margin: 20px 0;
    .wrong-code {
      color: #ff3b30;
    }
    .verify-note {
      color: #7a8189;
      font-size: 14px;
      span {
        color: #ff8200;
        font-weight: 500;
      }
    }
    .verify-note.resend-otp {
      color: #ff8200;
      font-weight: 500;
      // margin-top: 10px;
      cursor: pointer;
    }
  }
  .change-mobile {
    display: flex;
    img {
      margin-right: 10px;
    }
    span {
      color: #ff3b30;
      font-weight: 500;
      cursor: pointer;
    }
  }
}
</style>
